import {computed, Directive, Injector, OnInit} from '@angular/core';
import {destroy$} from '../destroyable';
import {ResponsiveColsService} from './responsive-cols.service';

@Directive({
    selector:   '[responsiveCols]',
    standalone: false,
    providers:  [
        ResponsiveColsService
    ]
})
export class ResponsiveColsDirective implements OnInit {

    public readonly destroy$ = destroy$();

    private readonly widths = computed<number[]>(() =>
        this.responsiveColsService.cols()
            .map(col => col.width())
    );

    constructor(
        private responsiveColsService: ResponsiveColsService,
        private injector: Injector
    ) {}

    public ngOnInit(): void {
        // effect(() => {
        //     const cols = this.responsiveColsService.cols();
        //
        //     console.warn(cols); // TODO
        // }, {injector: this.injector});

        // effect(() => {
        //     console.warn({widths: this.widths()}); // TODO
        // }, {injector: this.injector});
    }

}
